
import { createApi } from '@reduxjs/toolkit/query/react';

import { TChatbotSchema } from '@/types/chatbot';
import { TAgentConfig, TAgentConfigCreate, TAgentConfigUpdate, TChatbotConfig, TChatbotConfigCreate, TChatbotConfigUpdate } from '@/types/configs';

import { baseQueryWithReauth } from './utils';

export const configApi = createApi({
  reducerPath: 'configApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    createAgentConfig: build.mutation({
      query: (params: TAgentConfigCreate) => ({
        url: 'run-config/agent-run-config',
        method: 'POST',
        body: params,
        transformResponse: (response: TAgentConfig) => response,
      }),
    }),
    getAgentConfigs: build.query({
      query: (params: { agentId: string }) => ({
        url: 'run-config/agent-run-configs',
        method: 'GET',
        params,
      }),
    }),
    updateAgentConfig: build.mutation({
      query: (params: TAgentConfigUpdate) => ({
        url: 'run-config/agent-run-config',
        method: 'PATCH',
        body: params,
      }),
    }),
    getChatbotSchema: build.query({
      query: (params: { chatbotId: string }) => ({
        url: 'run-config/get-chatbot-schema',
        method: 'GET',
        params,
        transformResponse: (response: TChatbotSchema) => response,
      }),
    }),
    createChatbotConfig: build.mutation({
      query: (params: TChatbotConfigCreate) => ({
        url: 'run-config/chatbot-run-config',
        method: 'POST',
        body: params,
        transformResponse: (response: TChatbotConfig) => response,
      }),
    }),
    getChatbotConfigs: build.query({
      query: (params: { chatbotId: string }) => ({
        url: 'run-config/chatbot-run-configs',
        method: 'GET',
        params,
      }),
    }),
    updateChatbotConfig: build.mutation({
      query: (params: TChatbotConfigUpdate) => ({
        url: 'run-config/chatbot-run-config',
        method: 'PATCH',
        body: params,
      }),
    }),
  }),
});

export const {
  useCreateAgentConfigMutation,
  useGetAgentConfigsQuery,
  useUpdateAgentConfigMutation,
  useGetChatbotSchemaQuery,
  useCreateChatbotConfigMutation,
  useGetChatbotConfigsQuery,
  useUpdateChatbotConfigMutation,
} = configApi;